import React, { useState, useEffect } from 'react';
import Logo from './Logo'
import { BiChevronDown, BiMenu, BiX } from 'react-icons/bi';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="header-transparent sticky-fixed">
      <nav className={`navbar navbar-expand-lg fixed top-0 left-0 w-full z-[999] navbar-light navbar-link-white transition-all duration-300 ${isScrolled ? 'scrolled backdrop-blur-sm shadow-sm' : ''}`} style={isScrolled ? {backgroundColor: 'rgba(253,249,244,0.96)'} : {}}>
        <div className="navbar-fixed-bg absolute"></div>
        <div className="container relative flex flex-wrap items-center justify-between mx-auto px-4 min-h-[60px]">
          
          <a 
            className={`navbar-brand relative block font-bold text-3xl transition-colors duration-300 ${isScrolled ? 'text-gray-900' : 'text-white'}`} 
            href="#top"
            onClick={() => {setIsMobileMenuOpen(false); window.scrollTo({top: 0, behavior: 'smooth'});}}
          >
            <Logo />
          </a>

          <div className="flex items-center shrink-0 ml-auto lg:order-last">
            <div className="nav-item lg:ml-3 mr-4 lg:mr-0">
              <a href="#cta" className="btn text-white px-4 py-2 text-sm" style={{backgroundColor:'#B85C38'}}>Say Hello</a>
            </div>
            
            <button 
              className={`navbar-toggler order-last lg:hidden ml-3 p-2 transition-colors duration-300 ${isScrolled ? 'text-gray-700 hover:text-gray-500' : 'text-white hover:text-gray-300'}`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <BiX size={24} /> : <BiMenu size={24} />}
            </button>
          </div>

          <div className={`navbar-collapse w-full lg:w-auto lg:ml-auto lg:justify-end items-center lg:flex lg:basis-auto basis-full pt-4 lg:pt-0 ${isMobileMenuOpen ? 'block' : 'hidden lg:flex'}`}>
            
            <ul className={`navbar-nav flex flex-col lg:flex-row lg:bg-transparent w-full p-4 lg:p-0 rounded-lg lg:rounded-none mt-2 lg:mt-0 ${isScrolled ? 'bg-white dark:bg-black shadow-lg' : 'bg-black/90 dark:bg-black/90 lg:shadow-none'} lg:shadow-none`}>
              
              <li className="nav-item">
                <a className="nav-link" href="#who-we-are" onClick={() => setIsMobileMenuOpen(false)}>
                  Who We Are
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#about" onClick={() => setIsMobileMenuOpen(false)}>
                  About
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#services" onClick={() => setIsMobileMenuOpen(false)}>
                  Services
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#work-process" onClick={() => setIsMobileMenuOpen(false)}>
                  Our Way of Work
                </a>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;